import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import useVesselOwnerForm from "./useVesselOwnerFrom";
import { useNavigate } from "react-router-dom";

const defaultForm = {
  state: "",
  city: "",
  country: "",
  address: "",
};

const useFormVessOwner = () => {
  const { formDatas } = useVesselOwnerForm();
  const { token } = useContext(AuthContext);
  const [formData, setFormData] = useState(defaultForm);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    // Validate required fields
    if (!formData.address) {
      setError("Address is required");
      setLoading(false);
      return;
    }
    
    if (!formData.state) {
      setError("State is required");
      setLoading(false);
      return;
    }
    
    if (!formData.city) {
      setError("City is required");
      setLoading(false);
      return;
    }
    
    if (!formData.country) {
      setError("Country is required");
      setLoading(false);
      return;
    }
    
    try {
      const requestData = {
        companyName: formDatas.companyName || "",
        registrationNumber: formDatas.registrationNumber || "",
        address: formData.address,
        state: formData.state,
        city: formData.city,
        country: formData.country,
        phoneNumber: formDatas.phoneNumber || "",
        yearsInOperation: formDatas.yearsInOperation ? parseInt(formDatas.yearsInOperation) : 0,
        website: formDatas.website || "",
        linkedIn: formDatas.linkedIn || "",
        serviceCategory: formDatas.serviceCategory || [],
        keywords: formDatas.keywords || [],
      };

      // console.log(requestData)
  
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData), 
      });
  
      const resData = await res.json();
  
      if (!res.ok) {
        throw new Error(resData.message || "Failed to update profile");
      }
  
      setLoading(false);
      setSuccess("Profile updated successfully");
      localStorage.removeItem("vesselOwnerFormData");
      setTimeout(() => {
        setSuccess(null);
        navigate("/statutory_v_doc");
      }, 3000);
    } catch (error) {
      setError(error.message || "An error occurred while updating profile");
      setLoading(false);
    }
  };
  

  return {
    handleChange,
    handleSubmit,
    loading,
    formData,
    error,
    success,
  };
};

export default useFormVessOwner;
